import { useEffect } from "react";
import { MDBTableHead, MDBTable, MDBTableBody } from "mdbreact";
import { appInsights } from "../../config/appInsights";
import { formatMoney } from "accounting";
import { SignatoryApproval } from "../../custom-hooks/usePendingSignatorySetup";

import styles from "./style.module.scss";
import moment from "moment";

interface IDetails {
  data: {
    approverDetails: SignatoryApproval[];
  };
}

const SignatorySetupApproverDetails = ({
  data: { approverDetails },
}: IDetails) => {
  useEffect(() => {
    appInsights.trackPageView({
      name: "Details.tsx",
      isLoggedIn: true,
    });
  }, []);

  return (
    <div
      className={`table-view speed-1x animated fadeInRight ${styles.DetailsContainer}`}
    >
      <h1>Approver Details</h1>
      <div>
        <>
          <MDBTable
            responsive
            minimal="true"
            striped={false}
            bordered
            hover
            id="table-to-xls"
          >
            <MDBTableHead>
              <tr>
                <th>S/N</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Date Approved</th>
                <th>Status</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {approverDetails &&
                approverDetails.map((data, _id: number) => {
                  const {
                    firstName,
                    email,
                    lastName,
                    phoneNumber,
                    status,
                    approvedOn,
                  } = data;
                  return (
                    <tr key={_id}>
                      <td>{_id + 1}</td>
                      <td>{firstName}</td>
                      <td>{lastName}</td>
                      <td>{email}</td>
                      <td>{phoneNumber}</td>
                      <td>
                        {approvedOn
                          ? moment(approvedOn).format("DD/MM/YYYY hh:mm A")
                          : ""}
                      </td>
                      <td>{status}</td>
                    </tr>
                  );
                })}
            </MDBTableBody>
          </MDBTable>
        </>
      </div>
    </div>
  );
};

export default SignatorySetupApproverDetails;
